import httpService from "./httpService";

export default {
  insert(form) {
    return httpService.post("vbFlow", form);
  },

  update(flowId, form) {
    return httpService.put("vbFlow/" + flowId, form);
  },

  findById(id) {
    return httpService.get("vbFlow/" + id);
  },

  changeStatus(id) {
    return httpService.put(`vbFlow/${id}/changeStatus`);
  },
  changeDefault(id) {
    return httpService.put(`vbFlow/${id}/changeDefault`);
  }
};



// WEBPACK FOOTER //
// ./src/services/vbFlowService.js